import { MuiThemeProvider } from '@material-ui/core';
import React, { useEffect, useRef } from 'react';
import { theme } from './theme';
import { AiAssistantWrapper } from 'components/AiAssistant';
import { Footer } from 'components/footer';
import { setDDUserData } from 'datadog-rum';
import { identifyPosthogUser, resetPosthogUser, setPosthogAccountContext } from 'posthog';
import { useGlobalState } from 'store/reducers/reducer';
import './app.css';
const TestAccountNotice = () => (React.createElement("div", { className: "test-account-banner", role: "status" },
    "This is a Test Account \u2014 verifications use partially simulated results.",
    ' ',
    React.createElement("a", { href: "https://docs.vouched.id/docs/test-accounts", rel: "noopener noreferrer", target: "_blank" }, "Learn more")));
export const AppRoot = ({ children }) => {
    const { state } = useGlobalState();
    const { user, account, accessToken } = state;
    const identifiedUserId = useRef();
    const { id, email, accountId } = user ?? {};
    /**
     * Using a single effect here so the account context is always in place before
     * the identify call.
     */
    useEffect(() => {
        setPosthogAccountContext(account
            ? { account_id: String(account.id), is_test_account: account.isTest }
            : {});
        if (!user) {
            if (identifiedUserId.current) {
                resetPosthogUser();
                identifiedUserId.current = undefined;
            }
            return;
        }
        const userSid = user.sid;
        if (identifiedUserId.current === userSid) {
            return;
        }
        if (identifiedUserId.current) {
            resetPosthogUser();
        }
        // The user's own account rather than the one they are viewing, so it holds
        // still for a support admin and is safe to keep as a person property.
        identifyPosthogUser(userSid, {
            user_id: String(user.id),
            ...(user.initialAccountId
                ? { home_account_id: user.initialAccountId }
                : {})
        });
        identifiedUserId.current = userSid;
    }, [account, user]);
    useEffect(() => {
        if (!id || !accountId) {
            return;
        }
        setDDUserData(id, Number.parseInt(accountId, 10), email);
    }, [id, accountId, email]);
    return (React.createElement(MuiThemeProvider, { theme: theme },
        React.createElement("div", { className: "app" },
            React.createElement(AiAssistantWrapper, { accessToken: accessToken, user: user },
                account?.isTest && React.createElement(TestAccountNotice, null),
                children,
                React.createElement(Footer, null)))));
};
